import errorManager from '@/rollbar.js';

const disableAfterSave = () => {
  const initialDisabledSelector = '.js-disable-after-click';
  const disabledAdvSelector = 'disabled-adv';

  // rimuove l'attributo disabled, già presente in fase di rendering ssr
  const elementsJsDisable = document.querySelectorAll(initialDisabledSelector);
  elementsJsDisable.forEach((saveButton) => {
    saveButton.removeAttribute('disabled');
    saveButton.classList.remove(disabledAdvSelector);

    if (saveButton.closest('form')) {
      saveButton.addEventListener('click', (e) => {
        if (e.currentTarget.type === 'submit') {
          saveButton.classList.add(disabledAdvSelector);
        }
      });
    }
  });

  document.addEventListener(
    'submit',
    (ev) => {
      const buttons = ev.target.querySelectorAll(initialDisabledSelector);
      buttons.forEach((button) => {
        button.classList.add(disabledAdvSelector);
        button.setAttribute('disabled', true);
      });
    },
    true,
  );
};

const setObserver = () => {
  disableAfterSave();
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.disableAfterSave = {
  init,
};
